// Single source of truth for the marketing-site CTA. Pre-launch it renders a
// disabled "Coming soon" pill; flipping IS_LIVE to true (and providing APP_URL)
// re-enables all callsites at once. Styled with the marketing .btn classes
// (see index.css), not Tailwind theme colours.
const IS_LIVE = false;
const APP_URL = 'https://app.race-atlas.com';

interface Props {
  size?: 'sm' | 'md';
}

export const AppCta = ({ size = 'md' }: Props) => {
  const sizeStyle = size === 'sm' ? { padding: '8px 14px', fontSize: '13px' } : undefined;

  if (!IS_LIVE) {
    return (
      <button
        type="button"
        disabled
        aria-label="Race Atlas — coming soon"
        className="btn"
        style={{
          background: 'var(--line)',
          color: 'var(--muted)',
          cursor: 'not-allowed',
          ...sizeStyle,
        }}
      >
        Coming soon
      </button>
    );
  }

  return (
    <a className="btn btn-lime" href={APP_URL} style={sizeStyle}>
      Open the app
    </a>
  );
};
